import { langs } from "components/utils/option";
import i18n from "locales/i18n";
import { useTranslation } from "react-i18next";
import useModalStore from "store/modal";
import useUserStore from "store/user";
import { useLodGrpList, useLodList, useLogout } from "./service";
import ModalInner from "./modalInner";
import LodNmSelct from "./lodNmSelect";
import Select from "components/select";
import "./header.scss";

export default function Header() {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const user = useUserStore((state) => state.user);

  const onSetModal = useModalStore((state) => state.onSetModal);

  const { lodGrpList } = useLodGrpList();
  const { lodList } = useLodList();

  const { onLogout } = useLogout();

  const onManagerInf = () => {
    /**
     * 비밀번호 체크
     * 회원정보 가져오기
     * 수정 버튼으로 회원수정 모달창 오픈
     */
    onSetModal({
      title: t("md_ttl_mem"),
      isOpen: true,
      keep: true,
      styles: "max-w-[400px] overflow-visible",
      inner: <ModalInner />,
    });
  };

  return (
    <>
      <header>
        <div className="flex items-center gap-5">
          <h1>{t("manager_ttl")}</h1>
          {/* 홈에서 숙소 선택 함 */}
          <ul className="flex items-center gap-4 ">
            <li>{lodGrpList[0]?.lodGrpNm ?? "숙소그룹"}</li>
            <li className="w-[100px]">
              <LodNmSelct lodList={lodList} />
            </li>
          </ul>
        </div>
        <ul>
          <li>
            {(user?.manFstNm || "") + " " + (user?.manSurNm || "")}
            {langCd === "ko" ? "님" : ""}
          </li>
          <li onClick={onManagerInf}>{t("btn_mem")}</li>
          <li onClick={onLogout}>{t("btn_logout_cmm")}</li>
          <li>
            <div>
              <Select
                styles="w-[60px] h-[21px] border-1 bg-white"
                ulStyles="top-[24px]"
                name={"lng"}
                defaultValue={langs[0]}
                options={[
                  {
                    ko: "한국어",
                    en: "KOR",
                    value: "ko",
                    code: "ko",
                  },
                ]}
                onSelect={(li) => {
                  i18n.changeLanguage(li.code);
                }}
              />
            </div>
          </li>
        </ul>
      </header>
    </>
  );
}
